import { RPCs } from "../../../services/rpc.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { useRegionScope } from "../../../contexts/RegionScopeContext.js";
import "react";
import { ColorCircle } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/modules/Records/shared/SelectRecordTag.tsx
var SelectedSingle = (tag) => /* @__PURE__ */ jsxs("div", {
	className: "py-xs gap-x-sm inline-flex items-baseline text-sm",
	children: [/* @__PURE__ */ jsx(ColorCircle, {
		color: tag.color,
		variant: "neutral"
	}), /* @__PURE__ */ jsx("span", {
		className: "truncate",
		children: tag.title
	})]
});
var SelectedMulti = (tag, onRemove) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsxs("div", {
		className: "px-xs gap-x-xs inline-flex items-center overflow-hidden text-sm",
		children: [/* @__PURE__ */ jsx(ColorCircle, {
			color: tag.color,
			variant: "neutral"
		}), /* @__PURE__ */ jsx("span", {
			className: "truncate",
			children: tag.title
		})]
	})
});
var ListItem = (tagOption) => /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx(ColorCircle, {
	color: tagOption.color,
	marginRight: true,
	variant: "neutral"
}), /* @__PURE__ */ jsx("span", { children: tagOption.title })] });
function SelectRecordTag({ idFilter, limit = 15, multi, organizationId, regionIds, typeFilter, value, ...atalayaSelectProps }) {
	const regionScope = useRegionScope();
	const effectiveRegionIds = regionIds ?? regionScope;
	const responseOptionsExtractor = (data) => data?.tags;
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		args: {
			idFilter,
			organizationId,
			regionIds: effectiveRegionIds,
			typeFilter
		},
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ title }) => title,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Records.GetRecordTagsList.v1,
		requestFilterProp: "idFilter",
		selectedArgs: { organizationId },
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
}
//#endregion
export { SelectRecordTag };

//# sourceMappingURL=SelectRecordTag.js.map